import React from 'react'
import { useFormContext } from 'react-hook-form'

import { formMessages } from '@/constants/form-messages'
import { type FormWebsite } from '@/internal/types/form'

import * as styles from './submit.module.scss'

type Props = {
  value?: string
  isSubmitting: boolean
}
const Submit: React.FC<Props> = ({ value, isSubmitting }) => {
  const { getValues } = useFormContext()
  const { form } = getValues() as FormWebsite
  const labels = formMessages[form]
  return (
    <button
      className={styles.submit}
      data-testid="submit"
      disabled={isSubmitting}
    >
      {isSubmitting && (
        <>
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
          <span className="visually-hidden">Loading...</span>
        </>
      )}
      {!isSubmitting && (value ?? labels.submit)}
    </button>
  )
}
export default Submit
